export const colorTheme = {
    SYSTEM_ERROR: '#EE1060',
    SECONDARY: '#ebebeb',
    WHITE: '#FFF',
    BLACK: '#000',
    WASHED_BLACK: 'rgba(0, 0, 0, 0.87)',
    DARK_GREY: 'rgba(0, 0, 0, 0.6)',
};
